import React from "react";

const Toggle = ({ checked, onChange, disabled = false, label }) => {
  const handleKeyDown = (e) => {
    if (disabled) return;
    if (e.key === " " || e.key === "Enter") {
      e.preventDefault();
      onChange(!checked);
    }
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      tabIndex={0}
      onClick={() => !disabled && onChange(!checked)}
      onKeyDown={handleKeyDown}
      className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-shinobi-purple focus:ring-offset-2 focus:ring-offset-cyber-100 ${
        disabled ? "opacity-40 cursor-not-allowed" : ""
      } ${
        checked
          ? "border-transparent"
          : "border-slate-300 bg-slate-200 hover:border-slate-400"
      }`}
      style={
        checked
          ? {
              background: "#48b94c",
              borderColor: "transparent",
            }
          : {}
      }
    >
      <span
        className={`pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow-lg transition-transform duration-200 mt-0.5 ${
          checked ? "translate-x-5" : "translate-x-0.5"
        }`}
      />
    </button>
  );
};

export default Toggle;
